import React, {useState} from 'react';
import {
  Popover,
  Button,
} from '@material-ui/core';
import FilterList from '@material-ui/icons/FilterList';
import AddIcon from '@material-ui/icons/AddCircleOutlined';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutlined';
import IconButton from "@material-ui/core/IconButton";
import { Filter } from './Filter/Filter';
import cn from './ApplicationFilter.module.scss';

const defaultFilters = [
  'first_name',
  'last_name',
  'member_id',
  'contract_number',
  'soc_sec_number',
  'city',
  'record_source',
].map(
  field => ({ logicalModifier: "&", field, equalityModifier: "=", value: '' })
);

export function ApplicationFilter({ onSubmit, insuranceAgencies, serviceAgencies }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const [filters, setFilters] = useState(defaultFilters);

  function handleFilterOpen(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleFilterClose() {
    setAnchorEl(null);
  }

  function handleReset() {
    setFilters(defaultFilters);
  }

  function handleApply() {
    onSubmit(filters.filter(filter => filter.value !== ''));
    handleFilterClose();
  }

  function handleFilterChange(oldFilter, newFilter) {
    setFilters(filters.map(filter => filter === oldFilter ? newFilter : filter));
  }

  function handleAddFilter() {
    const [newRow] = defaultFilters;
    setFilters([...filters, {...newRow}]);
  }

  function handleFilterRemove(removedFilter) {
    setFilters(filters.filter(filter => filter !== removedFilter));
  }

  return (
    <div className={cn.container}>
      <IconButton onClick={handleFilterOpen} color="primary" className={cn.filterButton}>
        <FilterList />
      </IconButton>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handleFilterClose}
        classes={{
          root: cn.root,
          paper: cn.paper,
        }}
      >
        <div className={cn.form}>
          <div className={cn.formRow}>
            {filters.map((filter, index) => (
              <div className={cn.filter} key={filter.field}>
                <Filter
                  isFirst={index === 0}
                  filter={filter}
                  onChange={handleFilterChange}
                  insuranceAgencies={insuranceAgencies}
                  serviceAgencies={serviceAgencies}
                />
                 <RemoveIcon color="primary" onClick={() => handleFilterRemove(filter)} />
              </div>
            ))}
            <div className={cn.addRow}>
              <AddIcon color="primary" onClick={handleAddFilter} />
            </div>
          </div>
          <div className={cn.buttons}>
            <Button
              classes={{
                root: cn.button,
              }}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleApply}
            >
              Apply
            </Button>
          </div>
        </div>
      </Popover>
    </div>
  )
}
